import * as echarts from 'echarts/core'
import { LabelLayout } from 'echarts/features'
import { alpha, useTheme } from '@mui/material/styles'

// Lines' end labels move apart rather than print over each other where lines
// end together (`labelLayout` on a series).
echarts.use([LabelLayout])

// The Loop page's charts in one style: the axes and grid in the theme's text
// colour, the tooltip the Cost page's, and colours by the job they do
// (the dataviz skill's method).
//
// - **Categorical**, for series that are each a thing (a push kind, a lens's
//   group): the reference palette's first five slots, in this fixed order,
//   with a colour following its thing, never its rank. Checked with the
//   skill's validator against this admin's panels (#f3f3f3, #2d333b): every
//   gate passes in both modes; on light, four slots sit under 3:1, so every
//   line carries its name at its end and every chart has its numbers in a
//   table or tooltip.
// - **Emphasis**, for one series that is the point against its context: the
//   first slot against the muted gray.
const CATEGORICAL = {
  light: ['#2a78d6', '#eb6834', '#1baf7a', '#eda100', '#e87ba4'],
  dark: ['#3987e5', '#d95926', '#199e70', '#c98500', '#d55181'],
}

export const TOOLTIP = {
  backgroundColor: 'rgba(33, 33, 41, 0.94)',
  borderWidth: 0,
  textStyle: { color: '#fff', fontSize: 12 },
}

export const useChartStyle = () => {
  const theme = useTheme()
  const text = theme.palette.text.secondary
  const series = CATEGORICAL[theme.palette.mode]
  return {
    text,
    grid: alpha(text, 0.15),
    // The panel a chart sits on: the ring between overlapping marks.
    surface: theme.palette.background.paper,
    series,
    accent: series[0],
    muted: alpha(text, 0.35),
  }
}

// Where lines end together, their names step apart.
export const END_LABEL_LAYOUT = { moveOverlap: 'shiftY' }

// An axis in the house style: labels in the text colour, a recessive grid.
export const axisStyle = ({ text, grid }) => ({
  axisLabel: { color: text, fontSize: 10 },
  axisLine: { lineStyle: { color: grid } },
  axisTick: { show: false },
  splitLine: { lineStyle: { color: grid } },
})
